import React from 'react';
import ReactEcharts from 'echarts-for-react';

import '../../Assets/Ui/CardCount.css';

const getTrendIcon = (dif) => {
    if (dif > 0) return { icon: 'zmdi zmdi-long-arrow-up', cls: 'positive' };
    if (dif < 0) return { icon: 'zmdi zmdi-long-arrow-down', cls: 'negative' };
    return { icon: 'zmdi zmdi-minus', cls: '' };
};

const formatDif = (dif) => {
    const rounded = Math.round(dif);
    const formatted = Math.abs(rounded).toLocaleString('fr-FR');
    if (rounded > 0) return `+${formatted}`;
    if (rounded < 0) return `-${formatted}`;
    return '0';
};

const sparkOption = (points) => ({
    grid: { top: 4, bottom: 4, left: 0, right: 0 },
    xAxis: { type: 'category', show: false, boundaryGap: false, data: points.map((_, i) => i) },
    yAxis: { type: 'value', show: false },
    tooltip: { show: false },
    series: [{
        type: 'line',
        data: points,
        smooth: true,
        symbol: 'none',
        lineStyle: { color: 'rgba(255,255,255,0.95)', width: 1.5 },
        areaStyle: { color: 'rgba(255,255,255,0.18)' },
    }],
});

export const CardCount = props => {
    const trendIndicator = props.dif !== undefined ? getTrendIcon(props.dif) : null;
    const className = [
        'CardCount',
        'enhanced',
        props.gradient ? `gradient-${props.gradient}` : '',
        props.onClick ? 'clickable' : '',
    ].filter(Boolean).join(' ');

    return (
        <div
            className={className}
            style={{ backgroundColor: !props.gradient ? props.background : undefined, width: props.width }}
            onClick={props.onClick}
            role={props.onClick ? 'button' : undefined}
        >
            <div className="card-content">
                <div className="metric-section">
                    <p className="subtitle">{props.subtitle}</p>
                    <div className="counter-row">
                        <p className="textCounter">{props.number}</p>
                    </div>
                    {props.dif !== undefined && (
                        <div className={`trend-indicator ${trendIndicator.cls}`} style={{ marginTop: 8 }}>
                            <i className={trendIndicator.icon} />
                            <span className="trend-value">{formatDif(props.dif)}</span>
                            <span style={{ opacity: 0.75, fontWeight: 400, marginLeft: 4, fontSize: 12 }}>{props.trendLabel || 'vs hier'}</span>
                        </div>
                    )}
                </div>
                <div className="icon-section">
                    <i className={props.icon} />
                </div>
            </div>
            {props.spark && props.spark.length > 0 && (
                <div className="kpi-spark">
                    <ReactEcharts
                        option={sparkOption(props.spark)}
                        style={{ width: '100%', height: '100%' }}
                        opts={{ renderer: 'svg' }}
                    />
                </div>
            )}
            <div className="card-glow" />
        </div>
    );
};

export const KPICard = CardCount;
